import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../../core'
import * as goal from '../../goal'

export const RESOURCE = {
  payload: {
    modelId: goal.MODEL_ID,
    values: {
      // TODO: get multi-range to work
      // 'active_periods': new AtnMultirange<Date>(),
      [PartialId.Standard.create('active_periods')]: '{[1-1-2023,12-31-2025]}',
      [PartialId.Standard.create('code')]: '1.1.1',
      [PartialId.Standard.create('descr')]:
        'Expand opportunities for multidisciplinary learning that expose students to diverse ranges of perspectives and equip them with the ability to contribute to a free and just society.',
      [PartialId.Standard.create('id')]: 'gmu_1_1_1',
      [PartialId.Standard.create('name')]:
        'Multidisciplinary learning opportunities',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
